import React from "react";

import clsx from "clsx";
import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-appointment-scheduling.png";

import HeroSection from "../../hero-section";
import styles from "./index.module.css";
import TimelineContent from "./timeline-content";

const title = "Scheduling";

const Scheduling = () => (
  <div className={clsx("timeline-section-wrapper", styles.timelineSectionWrapper)}>
    <HeroSection title={title} className={styles.timelineSection}>
      <div className={styles.timelineSectionGrid}>
        <TimelineContent
          title={title}
          description="Whatever your process -- 1-touch, 2-touch, 3-touch, more-touch -- our internal scheduling tools allow you to find availability across multiple reps and auto-assign your best closers in seconds. Sync to Google Calendar and Zoom for virtual appointments."
          icon={
            <Image
              src="/images/icons/scheduling.svg"
              alt="Icon - Enerflo Scheduling"
              layout="responsive"
              height={64}
              width={69}
              quality={100}
              className="crispImage"
            />
          }
        />
        <figure className={clsx(styles.timelineFigure, styles.offsetContent)}>
          <div className="w-1/2 xs:w-2/5 md:w-full mx-auto">
            <Image
              src={FigureImage}
              alt="Enerflo’s internal scheduling tools sync with Google Calendar and Zoom to make appointment setting with solar customers quick and efficient."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
      </div>
    </HeroSection>
  </div>
);

export default Scheduling;
